import { Pencil } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { SalesLead } from '@/models/salesLead'

export function LeadAddress({ lead, onEdit }: { lead: SalesLead; onEdit: () => void }) {
  const cityStateZip = [[lead.city, lead.state].filter(Boolean).join(', '), lead.zipCode]
    .filter(Boolean)
    .join(' ')

  return (
    <div className="flex items-start gap-1">
      {lead.addressLine1 || cityStateZip ? (
        <div className="space-y-1">
          {lead.addressLine1 && <div>{lead.addressLine1}</div>}
          {cityStateZip && <div>{cityStateZip}</div>}
        </div>
      ) : (
        <span className="text-muted-foreground italic">Add address</span>
      )}
      <Button
        type="button"
        variant="iconOnly"
        className="text-muted-foreground hover:text-foreground inline-flex size-5 shrink-0 items-center justify-center rounded hover:bg-neutral-100"
        title="Edit address"
        aria-label="Edit address"
        onClick={onEdit}
      >
        <Pencil className="size-3" />
      </Button>
    </div>
  )
}
